import { useState, useEffect } from 'react';
import { Route } from '../types';

const MY_ROUTES_KEY = 'rrg_my_routes';

export function useMyRoutes() {
  const [myRoutes, setMyRoutes] = useState<Route[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  // Load my routes from localStorage on mount
  useEffect(() => {
    const savedRoutes = localStorage.getItem(MY_ROUTES_KEY);
    if (savedRoutes) {
      try {
        const parsedRoutes = JSON.parse(savedRoutes);
        setMyRoutes(parsedRoutes);
      } catch (error) {
        console.error('Error loading my routes:', error);
      }
    }
    setIsLoaded(true);
  }, []);

  // Save my routes to localStorage whenever they change (but not on initial load)
  useEffect(() => {
    if (isLoaded) {
      localStorage.setItem(MY_ROUTES_KEY, JSON.stringify(myRoutes));
    }
  }, [myRoutes, isLoaded]);

  const addRoute = (route: Route) => {
    setMyRoutes(prev => 
      prev.some(r => r.Route === route.Route)
        ? prev
        : [...prev, route]
    );
  };

  const removeRoute = (route: Route) => {
    setMyRoutes(prev => prev.filter(r => r.Route !== route.Route));
  };

  const isRouteInMyRoutes = (route: Route): boolean => {
    return myRoutes.some(r => r.Route === route.Route);
  };

  const clearAllRoutes = () => {
    setMyRoutes([]);
  };

  return {
    myRoutes,
    addRoute,
    removeRoute,
    isRouteInMyRoutes,
    clearAllRoutes,
  };
}
